export default "__VITE_ASSET__e$FCyB$S__"